<script lang="ts">
	import type { UserStatus, UserStatusType, SearchField } from 'utility/search-fields'
	import type { SvelteSet } from 'svelte/reactivity'
	import type { i18n } from 'types/common'

	import { onMount, type ComponentProps } from 'svelte'
	import { loadUserStatuses } from 'utility/search-fields'

	import Autocomplete from '@isoftdata/svelte-autocomplete'
	import EditModeControls from './EditModeControls.svelte'
	import Pin from './Pin.svelte'
	import { getContext } from 'svelte'

	interface Props extends Omit<
		ComponentProps<typeof Autocomplete<UserStatus | null>>,
		'value' | 'options' | 'getLabel'
	> {
		searchField: SearchField
		inEditMode: boolean
		pinnedSearchFields: SvelteSet<SearchField['key']> //Required
		selectedSearchFieldsKeys: SvelteSet<SearchField['key']> //Required
		userStatus?: UserStatus | null
		initialValue?: string
		statusType?: UserStatusType
		disabled?: boolean
	}

	let {
		searchField,
		inEditMode,
		pinnedSearchFields = $bindable(),
		selectedSearchFieldsKeys = $bindable(),
		userStatus = $bindable(null),
		initialValue,
		statusType = 'INVENTORY',
		disabled = false,
		...rest
	}: Props = $props()

	let userStatusList: Promise<Array<UserStatus>> | Array<UserStatus> = $state([])

	const { t: translate } = getContext<i18n>('i18next')

	onMount(async () => {
		userStatusList = await loadUserStatuses(statusType)
		if (initialValue) {
			userStatus = userStatusList.find(status => status.status === initialValue) || null
		}
	})
</script>

<EditModeControls
	{searchField}
	{inEditMode}
	{pinnedSearchFields}
	{selectedSearchFieldsKeys}
>
	<Autocomplete
		{...rest}
		label={translate('common:userStatus', 'User Status')}
		options={userStatusList}
		emptyValue={null}
		disabled={disabled || inEditMode}
		bind:value={userStatus}
		getLabel={option => (option ? `${option?.status} - ${option?.description}` : '')}
	>
		{#snippet hint()}
			<Pin isPinned={pinnedSearchFields.has(searchField.key)} />
		{/snippet}
	</Autocomplete>
</EditModeControls>
